/**
 * Datas date-only no painel: a API persiste em UTC (offset 0).
 * Parse/save nunca usam getters locais em strings `YYYY-MM-DD` / ISO date-only.
 */

/** `YYYY-MM-DD` → ISO meio-dia UTC (evita shift de fuso na validação da API). */
export function toServerDate(ymd?: string): string {
  if (!ymd?.trim()) return '';
  const raw = ymd.trim().slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
  return `${raw}T12:00:00.000Z`;
}

/** ISO / date-only / Date → `YYYY-MM-DD` via componentes UTC. */
export function fromServerDate(value?: string | Date | null): string {
  if (value == null || value === '') return '';
  if (typeof value === 'string') {
    const raw = value.trim();
    if (/^\d{4}-\d{2}-\d{2}/.test(raw)) return raw.slice(0, 10);
    const d = new Date(raw);
    if (Number.isNaN(d.getTime())) return '';
    return utcYmd(d);
  }
  if (Number.isNaN(value.getTime())) return '';
  return utcYmd(value);
}

/** `YYYY-MM-DD` → Date local (calendário), sem interpretar como UTC midnight. */
export function parseLocalYmd(ymd?: string): Date | undefined {
  if (!ymd?.trim()) return undefined;
  const m = ymd.trim().slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return undefined;
  const y = Number(m[1]);
  const month = Number(m[2]);
  const day = Number(m[3]);
  const d = new Date(y, month - 1, day);
  if (d.getFullYear() !== y || d.getMonth() !== month - 1 || d.getDate() !== day) return undefined;
  return d;
}

function utcYmd(d: Date): string {
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
